import * as fromDatatype from '../datatype-library/index';

export interface bl_aat_claim_document_approval_sequence_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  prev_guid: fromDatatype.GuidDataFieldInterface;
  next_guid: fromDatatype.GuidDataFieldInterface;
  claim_doc_line_guid: fromDatatype.GuidDataFieldInterface;
  approval_sequence: fromDatatype.IntegerDatatypeInterface;
  approval_date: fromDatatype.TimestampTzDatatypeInterface;
  approval_status: fromDatatype.VarcharDatatypeInterface;
  descr: fromDatatype.TextDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
  claim_doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
  claimant_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  claimant_name: fromDatatype.VarcharDatatypeInterface;
  approver_guid: fromDatatype.GuidDataFieldInterface;
  approver_name: fromDatatype.VarcharDatatypeInterface;
  approval_workflow_type: fromDatatype.VarcharDatatypeInterface;
  approval_request_queue_posting_status: fromDatatype.VarcharDatatypeInterface;
  approval_level: fromDatatype.IntegerDatatypeInterface;
  approval_quorum: fromDatatype.IntegerDatatypeInterface;
  approval_logic: fromDatatype.VarcharDatatypeInterface;
  total_required_approval_level: fromDatatype.IntegerDatatypeInterface;
  approval_level_count: fromDatatype.IntegerDatatypeInterface;
  approval_quorum_count: fromDatatype.IntegerDatatypeInterface;
  is_approver: boolean;
  approval_request_queue_posting_status_remarks: fromDatatype.TextDatatypeInterface;
  is_resubmitted_claim: boolean;
}

export class bl_aat_claim_document_approval_sequence_RowClass implements bl_aat_claim_document_approval_sequence_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  prev_guid: fromDatatype.GuidDataFieldInterface;
  next_guid: fromDatatype.GuidDataFieldInterface;
  claim_doc_line_guid: fromDatatype.GuidDataFieldInterface;
  approval_sequence: fromDatatype.IntegerDatatypeInterface;
  approval_date: fromDatatype.TimestampTzDatatypeInterface;
  approval_status: fromDatatype.VarcharDatatypeInterface;
  descr: fromDatatype.TextDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
  claim_doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
  claimant_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  claimant_name: fromDatatype.VarcharDatatypeInterface;
  approver_guid: fromDatatype.GuidDataFieldInterface;
  approver_name: fromDatatype.VarcharDatatypeInterface;
  approval_workflow_type: fromDatatype.VarcharDatatypeInterface;
  approval_request_queue_posting_status: fromDatatype.VarcharDatatypeInterface;
  approval_level: fromDatatype.IntegerDatatypeInterface;
  approval_quorum: fromDatatype.IntegerDatatypeInterface;
  approval_logic: fromDatatype.VarcharDatatypeInterface;
  total_required_approval_level: fromDatatype.IntegerDatatypeInterface;
  approval_level_count: fromDatatype.IntegerDatatypeInterface;
  approval_quorum_count: fromDatatype.IntegerDatatypeInterface;
  is_approver: boolean;
  approval_request_queue_posting_status_remarks: fromDatatype.TextDatatypeInterface;
  is_resubmitted_claim: boolean;
}
